module.exports = __webpack_public_path__ + "static/img/m6210.762f57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m6210.png
// module id = OKvt
// module chunks = 73